import type { SceneSection } from './manifest';
import { RitualSection } from './sections/RitualSection';
import { SaptapadiPheras } from './sections/SaptapadiPheras';

interface Props {
  section: SceneSection;
}

export function SceneSectionShell({ section }: Props) {
  if (section.ritualId === 'saptapadi') {
    return <SaptapadiPheras section={section} />;
  }
  return <RitualSection section={section} />;
}

